import React from 'react';
import { connect } from 'react-redux';
import NoBackground from '../../components/club-frame/header/no-background';
import SeoHead from '../../components/seo';
import TeamList from '../../components/team/list';
import { getClubTeams } from '../../store/clubs/selectors';
import CLUB_PROP_TYPES from '../../lib/prop-types/club';

const TeamListPage = ({ club }) => (
  <>
    <SeoHead
      club={club}
      descriptionTranslationKey="teams:team_list_meta_description"
      route="team.list"
      titleTranslationKey="teams:team_list_page_title"
    />
    <NoBackground />
    <TeamList club={club} sections={club.sections} />
  </>
);

TeamListPage.propTypes = {
  club: CLUB_PROP_TYPES.isRequired,
};

TeamListPage.getInitialProps = async () => ({
  activeSection: 'teams',
  namespacesRequired: ['common', 'teams'],
  pageType: 'team.list',
});

const mapStateToProps = (state, ownProps) => ({
  teams: getClubTeams(state, ownProps.club.id),
});

export default connect(mapStateToProps)(TeamListPage);
